import getCopilotPrioritizeSettings from 'owa-mail-copilot-settings/lib/selectors/getCopilotPrioritizeSettings';
import { getStore as getListViewStore, type SortColumn } from 'owa-mail-list-store';
import { getMailboxInfoFromTableViewId } from 'owa-mail-mailboxinfo/lib/getMailboxInfo';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';
import type { MailFolderTableQuery } from 'owa-mail-list-store';
import { isCopilotFeatureEnabled, isPrioritizeOnDemandEnabled } from 'owa-copilot-settings-utils';

export function shouldShowPrioritizeButton(tableViewId: string): boolean {
    const mailboxInfo = getMailboxInfoFromTableViewId(tableViewId);
    const tableView = getListViewStore().tableViews.get(tableViewId);
    const selectedSort = (tableView?.tableQuery as MailFolderTableQuery)?.sortBy;

    if (!selectedSort) {
        return false;
    }

    const isDescendingDateSort =
        selectedSort.sortColumn === 1 && selectedSort.sortDirection === 'Descending';
    if (!isDescendingDateSort && selectedSort.sortColumn !== 16) {
        return false;
    }

    const isInboxFolder = folderIdToName(tableView?.tableQuery?.folderId ?? '') === 'inbox';
    if (!isInboxFolder) {
        return false;
    }

    if (
        !isCopilotFeatureEnabled('Inbox', mailboxInfo, true /* skipLanguageCheck */) ||
        !getCopilotPrioritizeSettings(mailboxInfo).prioritizationEnabled
    ) {
        return false;
    }

    return isPrioritizeOnDemandEnabled(mailboxInfo);
}
